import {RubyPlayGameClientWrapper} from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapper';
import type {RelaxEventsHandler} from '@gongxigames/framework/integrations/relax/RelaxEventsHandler';
import {GameClientWrapperProperties, Xhr} from '@gongxigames/framework/slot';
import {RelaxErrorsHandler} from '@gongxigames/framework/integrations/relax/RelaxErrorsHandler';
import {ResponseBody, ServerResponseData} from '@gongxigames/framework/integrations/rubyplay/types';
import {RubyPlayGameClientWrapperSettings} from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapperSettings';
import {GameServerError} from '@gongxigames/framework/integrations/rubyplay/RubyPlayErrorsHandler';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {IPromotionLogicInterface, MultiSetsPromotion} from '@gongxigames/framework/promotions';

const HEADERS: any = {'Content-Type': 'application/json'};
const RC_PATH = '/relax/realityCheckChoice';

export class RelaxGameClientWrapper extends RubyPlayGameClientWrapper {
    public static NAME = 'relax';
    protected _relaxEventsHandler!: RelaxEventsHandler;
    protected _promotionLogicInterface: IPromotionLogicInterface = new MultiSetsPromotion();

    public initWrapper(properties: GameClientWrapperProperties): void {
        super.initWrapper(properties);

        const {RelaxEventsHandler: Constructor} = require('@gongxigames/framework/integrations/relax/RelaxEventsHandler');

        this._errors = new RelaxErrorsHandler(this._eventManager);
        this._relaxEventsHandler = new Constructor(this, this._eventManager);
    }

    protected onInitResponse(data: ServerResponseData): void {
        super.onInitResponse(data);

        this._relaxEventsHandler.setupPlayerCurrency(this.getSettings<RubyPlayGameClientWrapperSettings>().get('currency'));
    }

    protected shouldInitPromotion(body: ResponseBody, action?: Action): boolean {
        return this.isInitAction(action);
    }

    public sendRCChoiceOnServer(choice?: string): void {
        const url = this.getSettings<RubyPlayGameClientWrapperSettings>().get('serverUrl') + RC_PATH;
        const data = {sessionToken: this.getSettings<RubyPlayGameClientWrapperSettings>().get('playerSession'), choice};
        const serialObj = JSON.stringify(data);

        Xhr.post(url, serialObj, (body: ResponseBody) => {
            if (body.status === 'ok') {
                // do nothing - client RC choice was successfully sent to server
            } else {
                this._errors.handleGameServerError(body as GameServerError);
            }
        }, HEADERS, this.onErrorRequest.bind(this));
    }

    protected redirectToHomeUrl(): void {
        // if Relax operator supports handling exit from the game onExitGame() returns true
        // if not - we redirect by ourselves
        if (!this._relaxEventsHandler.onExitGame()) {
            let homeUrl = this.getSettings<RubyPlayGameClientWrapperSettings>().get('homeUrl') || '';
            // Relax add prefix fo homeUrl for some reason. It means that in case when
            // we should handle redirect to homeUrl we need to remove it from the url
            const relaxHomeUrlPrefix = 'action:';

            if (homeUrl?.startsWith(relaxHomeUrlPrefix)) {
                homeUrl = homeUrl.slice(relaxHomeUrlPrefix.length);
            }

            this.redirect(homeUrl);
        }
    }

    public getWager(): number {
        return this._client.getEngine().getMaxWager();
    }
}
